let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g8BpB")).then(() => parcelRequire('i78b1'));